import { render, staticRenderFns } from "./TargetDetail.vue?vue&type=template&id=e709bbd2&scoped=true"
import script from "./TargetDetail.vue?vue&type=script&lang=js"
export * from "./TargetDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e709bbd2",
  null
  
)

export default component.exports